import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App.jsx';
import { installGlobalErrorHandlers } from './app/errors/report-client-error.js';
import { registerServiceWorker } from './app/pwa/register-service-worker.js';
import './app/styles/index.css';

/**
 * Entry point.
 *
 * Three things happen here and nowhere else: global error handlers are attached,
 * the mount node is checked, and the tree is rendered. The old entry did none of
 * the first two, so a missing `#root`, a failed bundle or an unhandled rejection
 * all produced the same blank white page with no text.
 *
 * Audit references prevented here: main.jsx #2, main.jsx #3, index.html #5.
 */
installGlobalErrorHandlers();
registerServiceWorker();

const container = document.getElementById('root');

if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} else {
  // Nothing React can do at this point, so say so in plain text rather than
  // leaving a blank document.
  document.body.textContent =
    'EAX FUEL could not start: the page is missing its mount point. Please reload.';
  throw new Error('Mount node #root not found in the document');
}
